import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 待确认费用-分公司往来高级查询
export function branchTransactionsAdvancedSearch(requestBody) {
  return request({
    url: URL.act.chargeConfirmed.branchTransactionsAdvancedSearch,
    method: 'post',
    data: requestBody
  })
}

// 待确认费用-供应商费用
export function supplierChargeAdvancedSearch(requestBody) {
  return request({
    url: URL.act.chargeConfirmed.supplierChargeAdvancedSearch,
    method: 'post',
    data: requestBody
  })
}

// 外部费用同步审核通过
export function passChargeSyncOut(data) {
  return request({
    url: URL.act.chargeConfirmed.passChargeSyncOut,
    method: 'post',
    data
  })
}

// 外部费用同步审核不通过
export function notPassChargeSyncOut(data, params) {
  return request({
    url: URL.act.chargeConfirmed.notPassChargeSyncOut,
    method: 'post',
    data,
    params
  })
}
// 外部费用匹配业务
export function outChargeMatchJob(data) {
  return request({
    url: URL.act.chargeConfirmed.outChargeMatchJob,
    method: 'post',
    data
  })
}

// outChargeMatchSingle
export function outChargeMatchSingle(data) {
  return request({
    url: URL.act.chargeConfirmed.outChargeMatchSingle,
    method: 'post',
    data
  })
}

// 供应商费用更新job
export function outChargeUpdateJob(body) {
  const data = new FormData()
  for (const key in body) {
    data.append(key, body[key])
  }
  return request({
    url: URL.act.chargeConfirmed.outChargeUpdateJob,
    method: 'post',
    data
  })
}
